// extracted by mini-css-extract-plugin
export var icon = "cJ_j";